<template>
    <div v-wechat-title="title" v-if="surgeryId && surgeryId > 0">
        <div style="height: 10px;width: 100%;"></div>
        <el-row style="min-height: 31px; text-align: right">
            <el-col :span="16" class="align-left">
                <div v-for="(item, index) in this.eventConfig" :key="index" style="display: inline-block; margin-left: 5px; text-align: center">
                    <el-button type="primary" :disabled="(item.event && item.event.occur_time != ``) " size="mini" @click="saveOccurEvent(index, item)" style="width: 175px">
                        {{ item.label }}
                    </el-button>
                    <div class="local-anesthesia-date" v-show="showDatetime">
                        <item-input
                            v-if="item.event.occur_time == ``"
                            type="string"
                            readonly="readonly"
                            v-model="item.event.occur_time"
                            style="width: 175px; height: 40px; margin-top: 5px"
                            datetimeFormate="HH:mm"
                        ></item-input>
                        <input
                            class="inputlocal"
                            v-if="item.event.occur_time != ``"
                            v-model="item.event.local_occur_time"
                            type="datetime-local"
                            name="points"
                            max="2299-01-01T23:59"
                            @blur="changeOccurTime(item)"
                        />
                    </div>
                </div>
            </el-col>
            <el-col :span="8" class="align-right padding20 padding-none-v">
                <el-button type="danger" size="mini" v-if="isHavePermissions(`deleteInfo`) && this.analgesic_record_id > 0" @click="deleteView">删除</el-button>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`save`)" @click="saveInfo">保存</el-button>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`sync`)" @click="syncAnalgesiaInfo">同步</el-button>
                <el-button type="primary" size="mini" v-if="isHavePermissions(`postback`)" @click="postback">回传</el-button>
                <el-dropdown @command="print">
                    <el-button type="primary" size="mini" v-show="isHavePermissions(`print`)">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="printDoc">打印文书</el-dropdown-item>
                        <el-dropdown-item command="printAnalgesic">打印镇痛配方标签</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>
        </el-row>
        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: this.screenHeight - 160 + 'px' }">
            <el-row>
                <el-col :md="24" class="padding10">
                    <el-card :body-style="{ padding: '5px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">术后镇痛记录</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v">
                                <el-button type="primary" size="mini" @click="SaveAsRecordTemplate" v-if="isHavePermissions(`save_record_template`) || isHavePermissions(`save_record_regiontmp`)"
                                    >另存为模板</el-button
                                >
                                <el-button type="primary" size="mini" @click="loadRecordTemplatesView" v-if="isHavePermissions(`load_record_template`) || isHavePermissions(`load_record_regiontmp`)"
                                    >提取模板</el-button
                                >
                            </el-col>
                        </el-row>
                        <div class="card-content">
                            <cus-form ref="analgesia-info" :data="analgesiaInfo" :columns="analgesiaColumnList" @confirm="putAnalgesiaInfo"></cus-form>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row>
                <el-col :md="24" class="padding10">
                    <el-card :body-style="{ padding: '5px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">术后镇痛配方</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v">
                                <el-button type="primary" size="mini" @click="SaveAsTemplate" v-if="isHavePermissions(`save_template`) || isHavePermissions(`save_regiontmp`)">另存为模板</el-button>
                                <el-button type="primary" size="mini" @click="loadTemplatesView" v-if="isHavePermissions(`load_template`) || isHavePermissions(`load_regiontmp`)">提取模板</el-button>
                            </el-col>
                        </el-row>
                        <div class="card-content">
                            <ListView ref="analgesia-detail" :rowNoStyle="true" :datalist="analgesiaDetail" :columns="columnsList" @extrabutton-click="ExtraButtonClick"></ListView>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row>
                <el-col :md="24" class="padding10">
                    <el-card :body-style="{ padding: '5px' }">
                        <el-row class="card-header align-left line-height40" style="background: lightgray">
                            <el-col :span="16"><h3 class="margin20 margin-none-v">镇痛总结</h3></el-col>
                            <el-col :span="8" class="align-right padding20 padding-none-v"></el-col>
                        </el-row>
                        <div class="card-content">
                            <cus-form ref="analgesia_summary" :data="analgesiaInfo" :columns="summaryColumnList" @confirm="putAnalgesiaSummary"></cus-form>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </el-scrollbar>
        <form-dialog
            ref="form-saveas"
            title="另存为模板"
            :data="saveas.data"
            width="25%"
            class="form-table-h360"
            :visible.sync="saveas.dialogFormVisible"
            :columns="saveAsColumnList"
            @confirm="SaveAsConfirm"
        ></form-dialog>
        <cus-dialog class="table-h360" title="提取模板" :visible.sync="collectDrugs.dialogFormVisible" :close-on-click-modal="false" width="60%" @confirm="addTemplateToList">
            <div class="padding20 align-left">
                <span class="line-height35">请选模板:</span>
                <item-input
                    type="groupselect"
                    :collapseTags="false"
                    v-model="collectDrugs.selected_template"
                    :options="collectDrugs.analgesic_template"
                    :clearable="true"
                    style="display: inline-block; width: 300px"
                ></item-input>
            </div>
            <list-view
                ref="collectDrugslist"
                :columns="collectDrugscolumnList"
                :datalist="collectDrugs.datalist"
                :selectAll="true"
                :selection="true"
                @extrabutton-click="ExtraButtonClick"
                :showSequence="false"
            ></list-view>
        </cus-dialog>
        <form-dialog
            ref="form-recordsaveas"
            title="另存镇痛模板"
            :data="recordSaveas.data"
            width="25%"
            class="form-table-h360"
            :visible.sync="recordSaveas.dialogFormVisible"
            :columns="recordSaveAsColumnList"
            @confirm="SaveAsRecordConfirm"
        ></form-dialog>
        <cus-dialog class="table-h360" title="提取镇痛模板" :visible.sync="collectTemplate.dialogFormVisible" :close-on-click-modal="false" width="60%" @confirm="addRecordTemplateToList">
            <list-view
                ref="collectTemplateInfo"
                :singleChoice="true"
                :columns="collectTemplateColumnList"
                :datalist="collectTemplate.datalist"
                @extrabutton-click="ExtraButtonClick"
                :selection="true"
                :showSequence="true"
            ></list-view>
        </cus-dialog>
        <form-dialog :title="delInfo.title" :data="delInfo.data" :visible.sync="delInfo.dialogFormVisible" :columns="delInfo.columns" @confirm="saveDeleteInfo"></form-dialog>
    </div>
    <p v-else class="no-surgery">暂无手术</p>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `Analgesic`,
    props: {},
    data() {
        return {
            title: `术后镇痛`,
            queryInput: ``,
            surgeryId: this.$route.query.surgery_id,
            analgesic_record_id: null,
            token: this.$route.query.token,
            analgesiaInfo: {},
            analgesiaDetail: [],
            checkedRow: [],
            singleChoiceRow: {},
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            collectDrugs: {
                dialogFormVisible: false,
                selected_template: undefined,
                analgesic_template: [],
                cache_template: {},
                datalist: []
            },
            recordSaveas: {
                dialogFormVisible: false,
                data: {}
            },
            collectTemplate: {
                dialogFormVisible: false,
                datalist: []
            },
            delInfo: {
                title: `镇痛记录删除`,
                dialogFormVisible: false,
                data: {},
                columns: [
                    {
                        type: `string`,
                        prop: `delete_reason`,
                        label: `删除原因`
                    }
                ]
            },
            requiredFields: [],
            showDatetime: false,
            enum_businesstype: 111111,
            activeIndex: -1,
            eventConfig: [],
            surgeryInfo: {},
            activeward: ``
        }
    },
    computed: {
        ...mapGetters([`permissions`, `ward_auth`, `screenHeight`, `drug/drug_unit`, `currentUser`, `sys_enums`, `enum_region_type`, `localip/ipAddress`, `active_ward`]),
        analgesiaColumnList() {
            console.log(`244444444444444`, this.requiredFields)
            let list = [
                {
                    type: `multiselect`,
                    prop: `enum_analgesic_modes`,
                    label: `镇痛方式`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    showCount: 2,
                    collapseTags: false,
                    options: this.sys_enums.Enum_AnalgesicMode || [],
                    validate: _.includes(this.requiredFields, `镇痛方式`) && [{ required: true, message: `必填项目`, trigger: `blur` }],
                    config: { popperAppendToBody: true }
                },
                {
                    type: `select`,
                    prop: `enum_analgesia_pump_brand`,
                    label: `镇痛泵品牌`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12,
                    options: this.sys_enums.Enum_AnalgesiaPumpBrand || [],
                    config: { popperAppendToBody: true }
                },
                {
                    type: `datetime`,
                    prop: `analgesia_pump_start_time`,
                    label: `开机时间`,
                    isCreatable: true,
                    isEditable: true,
                    validate: _.includes(this.requiredFields, `开机时间`) && [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 6
                },
                {
                    type: `datetime`,
                    prop: `analgesia_pump_end_time`,
                    label: `停止时间`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `float`,
                    prop: `total_capacity`,
                    label: this.T(`analgesic_record.total_capacity`),
                    isCreatable: true,
                    isEditable: true,
                    validate: _.includes(this.requiredFields, this.T(`analgesic_record.total_capacity`)) && [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 6
                },
                {
                    type: `float`,
                    prop: `continuous_dose`,
                    label: this.T(`analgesic_record.continuous_dose`),
                    isCreatable: true,
                    isEditable: true,
                    validate: _.includes(this.requiredFields, this.T(`analgesic_record.continuous_dose`)) && [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 6
                },
                {
                    type: `float`,
                    prop: `single_dose`,
                    label: this.T(`analgesic_record.single_dose`),
                    isCreatable: true,
                    validate: _.includes(this.requiredFields, this.T(`analgesic_record.single_dose`)) && [{ required: true, message: `必填项目`, trigger: `blur` }],
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `integer`,
                    prop: `pcatimes`,
                    label: `PCA次数`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `float`,
                    prop: `first_dose`,
                    label: this.T(`analgesic_record.first_dose`),
                    isCreatable: true,
                    isEditable: true,
                    validate: _.includes(this.requiredFields, this.T(`analgesic_record.first_dose`)) && [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 6
                },
                {
                    type: `float`,
                    prop: `maximum_dose_per_hour`,
                    label: this.T(`analgesic_record.maximum_dose_per_hour`),
                    isCreatable: true,
                    isEditable: true,
                    colspan: 6
                },
                {
                    type: `integer`,
                    prop: `lock_time`,
                    label: this.T(`analgesic_record.lock_time`),
                    isCreatable: true,
                    isEditable: true,
                    validate: _.includes(this.requiredFields, this.T(`analgesic_record.lock_time`)) && [{ required: true, message: `必填项目`, trigger: `blur` }],
                    colspan: 6
                },
                {
                    type: `remoteselect`,
                    prop: `dispenser_lab`,
                    label: `配药人`,
                    isListable: true,
                    colspan: 6,
                    readonly: false,
                    options: `/api/AcisSystem/Worker/SearchForKey`
                },
                {
                    type: `remoteselect`,
                    prop: `pump_operator_lab`,
                    label: `上泵人`,
                    isListable: true,
                    colspan: 6,
                    readonly: false,
                    options: `/api/AcisSystem/Worker/SearchForKey`
                },
                {
                    type: `remoteselect`,
                    prop: `pump_puller_lab`,
                    label: `拔泵人`,
                    isListable: true,
                    colspan: 6,
                    readonly: false,
                    options: `/api/AcisSystem/Worker/SearchForKey`
                },
                {
                    type: `remoteselect`,
                    prop: `reviewer_lab`,
                    label: `审核人`,
                    isListable: true,
                    colspan: 6,
                    readonly: false,
                    options: `/api/AcisSystem/Worker/SearchForKey`
                },
                {
                    type: `string`,
                    prop: `recipe_remarks`,
                    label: `配方备注`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 18
                }
            ]
            return list
        },
        collectDrugscolumnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    width: `80`,
                    isKey: true
                },
                {
                    type: `remoteselect`,
                    prop: `dic_drug`,
                    label: `药品`,
                    options: `/api/AcisSystem/Drug/SearchAnalgesics`,
                    readonly: true,
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `dosage`,
                    label: `剂量`,
                    width: `100`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_unit_id`,
                    label: `单位`,
                    width: `100`,
                    options: _.filter(this[`drug/drug_unit`], { isspeed: false, isconcentration: false }).map(d => {
                        return {
                            label: `${d.label}`,
                            value: d.value,
                            disabled: d.disabled
                        }
                    }),
                    isListable: true
                }
            ]
        },
        collectTemplateColumnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                width: `80`,
                isKey: true
            },
            {
                type: `string`,
                prop: `template_name`,
                label: `模板名称`,
                width: `150`,
                isListable: true
            },
            {
                type: `multiselect`,
                prop: `enum_analgesic_modes`,
                label: `镇痛方式`,
                width: `300`,
                isListable: true,
                collapseTags: false,
                options: this.sys_enums.Enum_AnalgesicMode || [],
                config: { popperAppendToBody: true }
            },
            {
                type: `select`,
                prop: `enum_analgesia_pump_brand`,
                label: `镇痛泵品牌`,
                width: `150`,
                isListable: true,
                options: this.sys_enums.Enum_AnalgesiaPumpBrand || []
            },
            {
                type: `float`,
                prop: `total_capacity`,
                label: this.T(`analgesic_record.total_capacity`),
                width: `150`,
                isListable: true
            },
            {
                type: `float`,
                prop: `continuous_dose`,
                label: this.T(`analgesic_record.continuous_dose`),
                width: `150`,
                isListable: true
            },
            {
                type: `float`,
                prop: `single_dose`,
                label: this.T(`analgesic_record.single_dose`),
                width: `150`,
                isListable: true
            },
            {
                type: `integer`,
                prop: `pcatimes`,
                label: `PCA次数`,
                width: `150`,
                isListable: true
            },
            {
                type: `float`,
                prop: `first_dose`,
                label: this.T(`analgesic_record.first_dose`),
                width: `150`,
                isListable: true
            },
            {
                type: `float`,
                prop: `maximum_dose_per_hour`,
                label: this.T(`analgesic_record.maximum_dose_per_hour`),
                width: `150`,
                isListable: true
            },
            {
                type: `integer`,
                prop: `lock_time`,
                label: this.T(`analgesic_record.lock_time`),
                width: `150`,
                isListable: true
            },
            {
                type: `string`,
                prop: `recipe_remarks`,
                width: `150`,
                label: `配方备注`,
                isListable: true
            }]
        },
        summaryColumnList() {
            let me = this
            let list = [
                {
                    type: `string`,
                    prop: `analgesia_summary`,
                    label: `镇痛总结`,
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24
                },
                {
                    type: `multiselect`,
                    prop: `complications`,
                    showCount: 3,
                    collapseTags: false,
                    label: `并发症`,
                    // config: {
                    //     allowCreate: true
                    // },
                    options: (that, { row }) => {
                        return (me.sys_enums.Enum_Complication || []).map(x => {
                            return {
                                label: x.label,
                                value: x.label
                            }
                        })
                    },
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `multiselect`,
                    prop: `adverse_reactions`,
                    showCount: 3,
                    collapseTags: false,
                    label: `不良反应`,
                    // config: {
                    //     allowCreate: true
                    // },
                    options: (that, { row }) => {
                        return (me.sys_enums.Enum_AdverseReaction || []).map(x => {
                            return {
                                label: x.label,
                                value: x.label
                            }
                        })
                    },
                    isCreatable: true,
                    isEditable: true,
                    colspan: 12
                },
                {
                    type: `textarea`,
                    prop: `remark`,
                    label: `备注`,
                    config: {
                        minRows: 2
                    },
                    isCreatable: true,
                    isEditable: true,
                    colspan: 24
                }
            ]
            return list
        },
        columnsList() {
            let me = this
            let list = [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                },
                {
                    type: `remoteselect`,
                    prop: `dic_drug`,
                    label: `药品`,
                    isListable: true,
                    options: `/api/AcisSystem/Drug/SearchAnalgesics`,
                    readonly: (that, { row }) => {
                        return row.id > 0 && !me.isHavePermissions(`edit`)
                    },
                    change: (that, { row, index }) => {
                        if (row.dic_drug && row.dic_drug.value > 0) {
                            let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                            req.then(data => {
                                if (data) {
                                    let thisdose = 0
                                    if (data && data.UseDose != null && data.UseDose != 0) {
                                        thisdose = data.UseDose
                                    } else {
                                        thisdose = data.dose
                                    }
                                    this.$set(row, `dosage`, thisdose)
                                    this.$set(row, `dic_unit_id`, data.dic_unit_id)
                                    this.$set(row, `___index`, _.now())
                                    this.$set(row, `active`, true)

                                    let lastrow = me.analgesiaDetail[me.analgesiaDetail.length - 1]
                                    if (lastrow && lastrow.dic_drug && lastrow.dic_drug.value > 0 && me.isHavePermissions(`add`)) {
                                        me.analgesiaDetail.push({ active: true })
                                    }
                                }
                            }).catch(e => {})
                        } else {
                            this.$set(row, `dosage`, null)
                            this.$set(row, `dic_unit_id`, null)
                        }
                    }
                },
                {
                    type: `float`,
                    prop: `dosage`,
                    label: `剂量`,
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.id > 0 && !me.isHavePermissions(`edit`)
                    }
                },
                {
                    type: `select`,
                    prop: `dic_unit_id`,
                    label: `单位`,
                    isListable: true,
                    options: _.filter(this[`drug/drug_unit`], { isspeed: false, isconcentration: false }).map(d => {
                        return {
                            label: `${d.label}`,
                            value: d.value,
                            disabled: d.disabled
                        }
                    }),
                    readonly: (that, { row }) => {
                        return row.id > 0 && !me.isHavePermissions(`edit`)
                    }
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `140`,
                    isListable: true,
                    fixed: `right`,
                    readonly: false,
                    options: (that, { row }) => {
                        if (row.___index && me.isHavePermissions(`delete`)) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `removeItem`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
            return list
        },
        saveAsColumnList() {
            let cols = [
                {
                    type: `string`,
                    prop: `name`,
                    label: `名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    rowspan: 1,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    rowspan: 1,
                    options: `enum_region_type`,
                    default: 1,
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (!row.dic_ward_ids) {
                                var ids = []
                                ids.push(this.activeward || this.active_ward.value)
                                row.dic_ward_ids = ids
                            }
                        } else {
                            row.dic_ward_ids = null
                        }
                    }
                }
            ]
            if (this.isHavePermissions(`save_regiontmp`)) {
                if (!this.isHavePermissions(`save_template`)) {
                    cols[1].options = _.filter(this.enum_region_type, x => x.label == `区域` || x.value == 2)
                    cols[1].default = 2
                } else {
                    cols[1].options = this.enum_region_type
                }
                cols.push({
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    rowspan: 1,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                })
            } else {
                cols[1].options = _.filter(this.enum_region_type, x => x.label == `个人` || x.value == 1)
            }
            return cols
        },
        recordSaveAsColumnList() {
            let cols = [
                {
                    type: `string`,
                    prop: `template_name`,
                    label: `模板名称`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    rowspan: 1,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `radio`,
                    prop: `region_type`,
                    label: `可用范围`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    rowspan: 1,
                    options: `enum_region_type`,
                    default: 1,
                    change: (that, { row }) => {
                        if (row.region_type == 2) {
                            if (!row.dic_ward_ids) {
                                var ids = []
                                ids.push(this.activeward || this.active_ward.value)
                                row.dic_ward_ids = ids
                            }
                        } else {
                            row.dic_ward_ids = null
                        }
                    }
                }
            ]
            if (this.isHavePermissions(`save_record_regiontmp`)) {
                if (!this.isHavePermissions(`save_record_template`)) {
                    cols[1].options = _.filter(this.enum_region_type, x => x.label == `区域` || x.value == 2)
                    cols[1].default = 2
                } else {
                    cols[1].options = this.enum_region_type
                }
                cols.push({
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    isListable: true,
                    isEditable: true,
                    isCreatable: true,
                    rowspan: 1,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                })
            } else {
                cols[1].options = _.filter(this.enum_region_type, x => x.label == `个人` || x.value == 1)
            }
            return cols
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.activeward = null
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        // 获取工作站
        this.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(() => {
            console.log(`ipAddress`, this[`localip/ipAddress`])
            this.loadSurgery().then(() => {
                this.loadRequiredColumns()
                this.loadWorkstationConfig()
            })
        })
    },
    mounted() {
        this.$store.dispatch(`ADD_WARD_AUTH`)
        this.loadAnalgesiaInfo()
    },
    methods: {
        loadRequiredColumns() {
            let that = this
            let req = this.myaxios.get(`/api/Nursing/Prescription/GetAnalgesicRequiredColumns`)
            req.then(data => {
                that.requiredFields = data
                // that.requiredFields = _.filter(that.analgesiaColumnList, c => {
                //     return _.includes(requiredColumnNames, c.label)
                // })
                console.log(`553421412412`, _.includes(that.requiredFields, `镇痛方式`))
            }).catch(e => {
                console.log(e)
            })
        },
        loadSurgery() {
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    resolve()
                } else {
                    let req = this.myaxios.get(`/api/Preoperative/Apply/Get/${this.surgeryId}`)
                    req.then(data => {
                        this.surgeryInfo = data
                        resolve(data)
                    }).catch(e => reject(e))
                }
            })
        },
        loadWorkstationConfig() {
            console.log(this[`localip/ipAddress`])
            return new Promise((resolve, reject) => {
                if (!this[`localip/ipAddress`] || !this.surgeryInfo) {
                    resolve()
                } else {
                    this.activeward = `ow_${this.surgeryInfo.dic_operating_ward_id}`
                    let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${this[`localip/ipAddress`]}`)
                    req.then(data => {
                        console.log(`当前工作站`, data)
                        if (data && data.dic_recovery_ward_id) {
                            this.activeward = `rw_${this.surgeryInfo.dic_recovery_ward_id}`
                        }
                        resolve(data)
                    }).catch(e => {
                        console.log(e)
                        reject(e)
                    })
                }
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        isHavePermissions(permiskey) {
            return this.permissions && this.permissions.findIndex(item => item.permission === `analgesic_record:${permiskey}`) != -1
        },
        loadAnalgesiaInfo() {
            let that = this
            this.showDatetime = false
            that.analgesic_record_id = null
            that.analgesiaInfo = {}
            that.analgesiaDetail = []
            if (!this.surgeryId) {
                return
            }
            this.loadConfig()
            this.myaxios
                .get(`/api/AcisSystem/AnalgesicRecord/GetBySurgeryId?surgeryId=${this.surgeryId}`)
                .then(data => {
                    this.showDatetime = true
                    if (data) {
                        that.analgesic_record_id = data.id
                        // 镇痛方式
                        var ids = data.enum_analgesic_mode ? data.enum_analgesic_mode.split(`,`) : []
                        data.enum_analgesic_modes = ids.map(item => {
                            return +item
                        })
                        // 并发症
                        data.complications = data.complication ? data.complication.split(`,`) : []
                        // 不良反应
                        data.adverse_reactions = data.adverse_reaction ? data.adverse_reaction.split(`,`) : []
                        that.analgesiaInfo = data || { biz_surgery_info_id: this.surgeryId }
                        if (data && data.analgesicsDetails) {
                            that.analgesiaDetail = _.map(data.analgesicsDetails, (d, index) => {
                                d.___index = _.now() + (index + 1) * 1000
                                return d
                            })
                        }
                    }
                    if (that.isHavePermissions(`add`)) {
                        that.analgesiaDetail.push({ active: true })
                    }
                })
                .catch(e => { })
        },
        loadConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/OtherBusiness/BusinessKeyEventConfig/GetConfig?enum_businesstype=${this.enum_businesstype}`)
                let req2 = this.myaxios.get(`/api/OtherBusiness/BusinessOccurEvent/GetBusinessOccurEvent?surgeryInfoId=${this.surgeryId}&enum_businesstype=${this.enum_businesstype}`)
                this.myaxios.all(req, req2).then(([config, events]) => {
                    console.log(`a`, config)
                    console.log(`b`, events)
                    this.activeIndex = events.length
                    this.eventConfig = _.map(config, d => {
                        let et = _.find(events, evt => evt.dic_event_id == d.value)
                        d.event = (et && {
                            id: et.id,
                            dic_event_id: d.value,
                            biz_surgery_info_id: this.surgeryId,
                            enum_business_type: this.enum_businesstype,
                            occur_time: et.occur_time,
                            local_occur_time: that.timeForm(et.occur_time)
                        }) || {
                            dic_event_id: d.value,
                            biz_surgery_info_id: this.surgeryId,
                            enum_business_type: this.enum_businesstype,
                            occur_time: ``
                        }
                        return d
                    })
                    console.log(`c`, this.eventConfig)
                    resolve()
                })
            })
        },
        saveOccurEvent(index, item) {
            var firstEvent = this.eventConfig[0] && this.eventConfig[0].event
            if (index != 0 && firstEvent && (!firstEvent.occur_time || firstEvent.occur_time == ``)) {
                this.$message.error(`患者尚未${this.eventConfig[0].label},请先执行该事件`)
                return
            }
            if (!item.event.occurdt) {
                item.event.occurdt = this.$moment().format(`YYYY/MM/DD HH:mm`)
            }
            this.saveOccurEventbody(index, item)
        },
        saveOccurEventbody(index, item) {
            let that = this
            that.myaxios[item.event.id ? `put` : `post`](`/api/OtherBusiness/BusinessOccurEvent/${item.event.id ? `PutOccurEvent` : `PostOccurEvent`}`, item.event)
                .then(data => {
                    let msg = item.event.id ? `修改` : `添加`
                    this.$message.success(msg + `‘` + item.label + `’` + `事件成功`)
                    this.loadAnalgesiaInfo()
                }).catch((action) => {
                    this.loadAnalgesiaInfo().then(data => { })
                })
        },
        changeOccurTime(item) {
            console.log(item)
            let oldtime = this.$moment(item.event.occur_time).format(`YYYY/MM/DD HH:mm`)
            let newtime = this.$moment(item.event.local_occur_time).format(`YYYY/MM/DD HH:mm`)
            console.log(oldtime)
            console.log(newtime)
            if (oldtime == newtime) {
                return
            }
            item.event.occur_time = this.$moment(item.event.local_occur_time).format(`YYYY/MM/DD HH:mm`)
            this.saveOccurEventbody(1, item)
        },
        timeForm(time) {
            console.log(time)
            let now = new Date(this.$moment(time).format(`YYYY/MM/DD HH:mm`))
            console.log(now)
            let year = now.getFullYear()
            let month = now.getMonth() + 1
            month = month < 10 ? `0` + month : month
            let day = now.getDate()
            day = day < 10 ? `0` + day : day
            let hour = now.getHours()
            hour = hour < 10 ? `0` + hour : hour
            let min = now.getMinutes()
            min = min < 10 ? `0` + min : min
            let timeValue = year + `-` + month + `-` + day + `T` + hour + `:` + min
            return timeValue
        },
        SaveAsTemplate() {
            let tmpldatalist = _.filter(this.analgesiaDetail, x => x.dic_drug && x.dic_drug.value > 0)
            if (!tmpldatalist || tmpldatalist.length == 0) {
                this.$message.warning(`没有镇痛配方数据，请确认后重试！`)
                return
            }
            this.saveas.dialogFormVisible = true
        },
        SaveAsConfirm(row) {
            if ((row.region_type == 2 && !row.dic_ward_ids) || row.dic_ward_ids == ``) {
                this.$message.warning(`请选择可用区域！`)
                return
            }
            let postData = {
                name: row.name,
                region_type: row.region_type,
                items: _.filter(this.analgesiaDetail, x => x.dic_drug && x.dic_drug.value > 0).map(d => {
                    return {
                        dic_drug_id: d.dic_drug.value,
                        dosage: d.dosage,
                        dic_unit_id: d.dic_unit_id
                    }
                })
            }
            if (this.isHavePermissions(`save_regiontmp`) && row.region_type == 2) {
                let operatingids = []
                let recoveryids = []
                row.dic_ward_ids.map(d => {
                    let operatingid = _.startsWith(d, `ow_`) ? d.substr(3) : 0
                    let recoveryid = _.startsWith(d, `rw_`) ? d.substr(3) : 0
                    if (operatingid != 0) {
                        operatingids.push(operatingid)
                    }
                    if (recoveryid != 0) {
                        recoveryids.push(recoveryid)
                    }
                })
                postData.dic_operating_ward_id = _.join(operatingids, `,`)
                postData.dic_recovery_ward_id = _.join(recoveryids, `,`)
            }
            this.myaxios.post(`/api/AcisSystem/AnalgesicTemplate/Post`, postData).then(data => {
                this.$message.success(`另存为模板成功`)
                this.saveas.dialogFormVisible = false
            })
        },
        loadTemplatesView() {
            // 加载可选模板，弹出模板选择框
            this.collectDrugs.selected_template = undefined
            this.collectDrugs.datalist = []
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/AcisSystem/AnalgesicTemplate/Get`)
                req.then(data => {
                    data = _.filter(data, d => {
                        if (!this.isHavePermissions(`load_regiontmp`)) {
                            return d.region_type == 1 && d.owner == this.currentUser.username
                        } else {
                            let allRegionValue = []
                            _.map(that.ward_auth, d => {
                                allRegionValue.push(d.value)
                            })
                            let owids = (d.dic_operating_ward_id && d.dic_operating_ward_id != `` && d.dic_operating_ward_id.split(`,`)) || []
                            let hasow =
                                _.filter(owids, c => {
                                    return _.includes(allRegionValue, `ow_${c}`)
                                }) || []
                            let rwids = (d.dic_recovery_ward_id && d.dic_recovery_ward_id != `` && d.dic_recovery_ward_id.split(`,`)) || []
                            let hasrw =
                                _.filter(rwids, c => {
                                    return _.includes(allRegionValue, `rw_${c}`)
                                }) || []
                            if (this.isHavePermissions(`load_regiontmp`) && !this.isHavePermissions(`load_template`)) {
                                return d.region_type == 2 && (hasow.length > 0 || hasrw.length > 0)
                            } else {
                                return (d.region_type == 2 && (hasow.length > 0 || hasrw.length > 0)) || (d.region_type == 1 && d.owner == this.currentUser.username)
                            }
                        }
                    })
                    let groupId = _.groupBy(data, `id`)
                    let ts = _.reduce(
                        groupId,
                        function(result, g, key) {
                            let region = g.map(s => {
                                let ows =
                                    s.dic_operating_ward_id &&
                                    s.dic_operating_ward_id.split(`,`).map(item => {
                                        let data = _.find(that.ward_auth, { value: `ow_${item}` })
                                        return data && data.label
                                    })
                                let rws =
                                    s.dic_recovery_ward_id &&
                                    s.dic_recovery_ward_id.split(`,`).map(item => {
                                        let data = _.find(that.ward_auth, { value: `rw_${item}` })
                                        return data && data.label
                                    })
                                let ow =
                                    ows &&
                                    _.join(
                                        ows.filter(t => t),
                                        `,`
                                    )
                                let rw =
                                    rws &&
                                    _.join(
                                        rws.filter(t => t),
                                        `,`
                                    )
                                return ow || rw || that.currentUser.dic_worker_name
                            })
                            let r = {
                                label: g[0].name,
                                value: g[0].id,
                                jianpin: g[0].abbr,
                                code: region.join(`|`),
                                group: _.includes(region, that.currentUser.dic_worker_name) ? `个人模板` : `区域模板`
                            }
                            result.push(r)
                            return result
                        },
                        []
                    )
                    this.collectDrugs.analgesic_template = _.orderBy(ts, `group`)
                    this.collectDrugs.dialogFormVisible = true
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        SaveAsRecordTemplate() {
            let that = this
            let recordInfo = that.$refs[`analgesia-info`] && that.$refs[`analgesia-info`].formdata
            if (!recordInfo || !recordInfo.enum_analgesic_modes || recordInfo.enum_analgesic_modes.length == 0) {
                this.$message.warning(`请填写镇痛信息！`)
                return
            }
            this.recordSaveas.dialogFormVisible = true
        },
        SaveAsRecordConfirm(row) {
            let that = this
            if ((row.region_type == 2 && !row.dic_ward_ids) || row.dic_ward_ids == ``) {
                this.$message.warning(`请选择可用区域！`)
                return
            }
            let recordInfo = that.$refs[`analgesia-info`] && that.$refs[`analgesia-info`].formdata
            let postData = {
                template_name: row.template_name,
                enum_analgesic_mode: recordInfo.enum_analgesic_modes && recordInfo.enum_analgesic_modes.join(`,`),
                enum_analgesia_pump_brand: recordInfo.enum_analgesia_pump_brand,
                total_capacity: recordInfo.total_capacity,
                continuous_dose: recordInfo.continuous_dose,
                single_dose: recordInfo.single_dose,
                pcatimes: recordInfo.pcatimes,
                first_dose: recordInfo.first_dose,
                maximum_dose_per_hour: recordInfo.maximum_dose_per_hour,
                lock_time: recordInfo.lock_time,
                recipe_remarks: recordInfo.recipe_remarks,
                regions: row.region_type == 1
                    ? [{ owner: this.currentUser.username }]
                    : row.dic_ward_ids.map(d => {
                        return {
                            sys_analgesic_record_template_id: 0,
                            dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                            dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                        }
                    })
            }

            this.myaxios.post(`/api/AcisSystem/AnalgesicRecordTemplate/Post`, postData).then(data => {
                this.$message.success(`另存为模板成功`)
                this.recordSaveas.dialogFormVisible = false
            })
        },
        loadRecordTemplatesView() {
            // 加载可选模板
            this.collectTemplate.datalist = []
            let that = this
            let regionType = this.isHavePermissions(`load_record_regiontmp`) || false
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/AcisSystem/AnalgesicRecordTemplate/Get`)
                req.then(data => {
                    data = _.filter(data, d => {
                        if (!regionType) {
                            return d.region_type == 1 && _.find(d.regions, { owner: that.currentUser.username })
                        } else {
                            return (d.region_type == 1 && _.find(d.regions, { owner: that.currentUser.username })) ||
                                (d.region_type == 2 && _.find(d.regions, { wardstr: that.activeward || that.active_ward.value }))
                        }
                    })
                    this.collectTemplate.datalist = data
                    this.collectTemplate.dialogFormVisible = true
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        addRecordTemplateToList() {
            let that = this
            let oldInfo = _.cloneDeep(that.analgesiaInfo)
            if (that.singleChoiceRow) {
                let data = that.singleChoiceRow
                that.analgesiaInfo = {
                    enum_analgesic_mode: data.enum_analgesic_mode,
                    enum_analgesic_modes: data.enum_analgesic_modes,
                    enum_analgesia_pump_brand: data.enum_analgesia_pump_brand,
                    total_capacity: data.total_capacity,
                    continuous_dose: data.continuous_dose,
                    single_dose: data.single_dose,
                    pcatimes: data.pcatimes,
                    first_dose: data.first_dose,
                    maximum_dose_per_hour: data.maximum_dose_per_hour,
                    lock_time: data.lock_time,
                    recipe_remarks: data.recipe_remarks,
                    analgesia_pump_start_time: oldInfo.analgesia_pump_start_time,
                    analgesia_pump_end_time: oldInfo.analgesia_pump_end_time,
                    analgesia_summary: oldInfo.analgesia_summary,
                    complications: oldInfo.complications,
                    adverse_reactions: oldInfo.adverse_reactions,
                    remark: oldInfo.remark
                }
                this.singleChoiceRow = {}
                this.collectTemplate.dialogFormVisible = false
            } else {
                this.$message.warning(`请选择对应模板`)
                return false
            }
        },
        selectionSingleChoiceChange({ row }) {
            this.singleChoiceRow = row
        },
        selectionChange({ row }) {
            this.checkedRow = row
        },
        addTemplateToList() {
            let selectedTempItems = this.checkedRow
            if (selectedTempItems && selectedTempItems.length > 0) {
                _.map(this.checkedRow, (d, index) => {
                    this.analgesiaDetail.splice(this.isHavePermissions(`add`) ? this.analgesiaDetail.length - 1 : this.analgesiaDetail.length, 0, {
                        dic_drug: d.dic_drug,
                        dic_drug_id: d.dic_drug_id,
                        dosage: d.dosage,
                        dic_unit_id: d.dic_unit_id,
                        ___index: _.now() + (index + 1) * 2000
                    })
                })
                this.checkedRow = []
                this.collectDrugs.dialogFormVisible = false
            } else {
                this.$message.warning(`未选择镇痛用药`)
                return false
            }
        },
        putAnalgesiaInfo(data) {
            let that = this
            var firstEvent = this.eventConfig[0] && this.eventConfig[0].event
            if (firstEvent && (!firstEvent.occur_time || firstEvent.occur_time == ``)) {
                this.$message.error(`患者尚未${this.eventConfig[0].label},请先执行该事件`)
                return
            }
            that.analgesiaInfo = {
                id: this.analgesic_record_id,
                biz_surgery_info_id: this.surgeryId,
                enum_analgesic_mode: data.enum_analgesic_modes && data.enum_analgesic_modes.join(`,`),
                enum_analgesia_pump_brand: data.enum_analgesia_pump_brand,
                analgesia_pump_start_time: data.analgesia_pump_start_time,
                analgesia_pump_end_time: data.analgesia_pump_end_time,
                total_capacity: data.total_capacity,
                continuous_dose: data.continuous_dose,
                single_dose: data.single_dose,
                pcatimes: data.pcatimes,
                first_dose: data.first_dose,
                maximum_dose_per_hour: data.maximum_dose_per_hour,
                lock_time: data.lock_time,
                dispenser: data.dispenser_lab && data.dispenser_lab.value,
                pump_operator: data.pump_operator_lab && data.pump_operator_lab.value,
                pump_puller: data.pump_puller_lab && data.pump_puller_lab.value,
                reviewer: data.reviewer_lab && data.reviewer_lab.value,
                recipe_remarks: data.recipe_remarks
            }
            that.$refs[`analgesia_summary`].confirm()
        },
        putAnalgesiaSummary(data) {
            let that = this
            return new Promise((resolve, reject) => {
                var details = _.filter(that.analgesiaDetail, d => d.dic_drug && d.dic_drug.value > 0)
                if (details.length == 0) {
                    this.$message.error(`请填写镇痛配方！`)
                    return
                }
                try {
                    details.forEach(d => {
                        if (!d.dic_drug) {
                            this.$message.error(`请选择药品！`)
                            throw new Error(`EndIterative`)
                        }
                        if (!d.dosage) {
                            this.$message.error(`请输入药品剂量！`)
                            throw new Error(`EndIterative`)
                        }
                        if (!d.dic_unit_id || d.dic_unit_id == ``) {
                            this.$message.error(`请选择药品单位！`)
                            throw new Error(`EndIterative`)
                        }
                    })
                } catch (e) {
                    if (e.message != `EndIterative`) throw e
                    return
                }
                that.analgesiaInfo.analgesia_summary = data.analgesia_summary
                that.analgesiaInfo.complication = data.complications && data.complications.join(`,`)
                that.analgesiaInfo.adverse_reaction = data.adverse_reactions && data.adverse_reactions.join(`,`)
                that.analgesiaInfo.remark = data.remark

                that.analgesiaInfo.analgesicsDetails = details.map(d => {
                    return {
                        id: d.id,
                        biz_surgery_info_id: this.surgeryId,
                        biz_analgesic_record_id: this.analgesic_record_id,
                        dic_drug_id: d.dic_drug.value,
                        dosage: d.dosage,
                        dic_unit_id: d.dic_unit_id
                    }
                })
                if (!that.analgesiaInfo.id || that.analgesiaInfo.id <= 0) {
                    this.myaxios.post(`/api/AcisSystem/AnalgesicRecord/Post`, that.analgesiaInfo).then(data => {
                        this.$message.success(`保存成功`)
                        this.loadAnalgesiaInfo()
                    }).catch(data => {
                        this.loadAnalgesiaInfo()
                    })
                } else {
                    let postList = _.map(
                        _.filter(details, d => !d.id),
                        d => {
                            return {
                                biz_surgery_info_id: this.surgeryId,
                                biz_analgesic_record_id: this.analgesiaInfo.id,
                                dic_drug_id: d.dic_drug.value,
                                dosage: d.dosage,
                                dic_unit_id: d.dic_unit_id
                            }
                        }
                    )
                    let putList = _.map(
                        _.filter(details, d => d.id > 0),
                        d => {
                            return {
                                id: d.id,
                                biz_surgery_info_id: this.surgeryId,
                                biz_analgesic_record_id: this.analgesiaInfo.id,
                                dic_drug_id: d.dic_drug.value,
                                dosage: d.dosage,
                                dic_unit_id: d.dic_unit_id
                            }
                        }
                    )
                    console.log(this.analgesiaInfo)
                    let req1 = this.myaxios.put(`/api/AcisSystem/AnalgesicRecord/Put`, that.analgesiaInfo)
                    let req2 = this.myaxios.post(`/api/AcisSystem/AnalgesicsDetail/PostMany`, postList)
                    let req3 = this.myaxios.put(`/api/AcisSystem/AnalgesicsDetail/PutMany`, putList)
                    this.myaxios
                        .all(req1, req2, req3)
                        .then(() => {
                            this.$message.success(`保存成功`)
                            resolve(this.loadAnalgesiaInfo())
                        })
                        .catch(e => {
                            this.loadAnalgesiaInfo()
                            reject(e)
                        })
                }
            })
        },
        saveInfo() {
            this.$refs[`analgesia-info`].confirm()
        },
        deleteView() {
            let that = this
            this.$confirm(`确定删除当前患者镇痛记录?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                that.delInfo.dialogFormVisible = true
            })
        },
        saveDeleteInfo(row) {
            let that = this
            let requestData = {
                biz_surgery_info_id: that.surgeryId,
                id: that.analgesic_record_id,
                is_deleted: true,
                delete_reason: row.delete_reason
            }
            let req = this.myaxios.put(`/api/AcisSystem/AnalgesicRecord/Put`, requestData)
            req.then(data => {
                // 调用手术回写
                that.delInfo.dialogFormVisible = false
                that.$message.success(`删除成功`)
                that.loadAnalgesiaInfo()
            }).catch(e => {})
        },
        syncAnalgesiaInfo() {
            this.$confirm(`同步后已有数据将会被覆盖,确认同步吗?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.post(`/api/AcisSystem/AnalgesicRecord/SyncAnalgesiaInfo?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    if (data) {
                        if (data.status) {
                            this.$message.info(`同步成功`)
                            this.loadAnalgesiaInfo()
                        } else {
                            this.$message.error(data.msg)
                        }
                    }
                }).catch(e => {
                    console.log(e)
                    this.$message.error(e)
                })
            })
        },
        postback() {
            this.$confirm(`确认上传数据吗?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.post(`/api/AcisSystem/AnalgesicRecord/BackAnalgesiaInfo?surgeryId=${this.surgeryId}`)
                req.then(data => {
                    if (data) {
                        if (data.status) {
                            this.$message.info(data.msg)
                        } else {
                            this.$message.error(data.msg)
                        }
                    }
                }).catch(e => {
                    console.log(e)
                    this.$message.error(e)
                })
            })
        },
        print(command) {
            let doc = ``
            if (command == `printDoc`) {
                doc = `SHZT001`
            }
            if (command == `printAnalgesic`) {
                doc = `SHZT002`
            }
            let docId = this.$root.DOCUMENT[doc]
            let req = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: docId,
                            id1: this.surgeryId
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        removeItem({ row, index }) {
            let msg = ``
            if (row.id > 0) {
                msg = `将直接删除药品数据，`
            }
            this.$confirm(`${msg}是否确认删除?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `error`
            })
                .then(() => {
                    if (row.id > 0) {
                        let req = this.myaxios.delete(`/api/AcisSystem/AnalgesicsDetail/Delete/${row.id}`)
                        req.then(data => {
                            this.analgesiaDetail.splice(index, 1)
                        })
                    } else {
                        this.analgesiaDetail.splice(index, 1)
                    }
                })
                .catch(() => {})
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadAnalgesiaInfo()
        },
        'collectDrugs.selected_template': function(newval, oldval) {
            // 加载已选模板详情
            if (!newval) return
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/AnalgesicTemplate/Get/${newval}`)
            req.then(template => {
                var templateitems = template.items
                // let msg = ``
                // _.filter(templateitems, x => x.dic_drug && x.dic_drug.disabled == true).map(d => {
                //     msg += d.dic_drug.label + `;`
                // })
                // if (msg != ``) {
                //     this.$alert(msg + `已被禁用或者删除！`, `提示`, {
                //         dangerouslyUseHTMLString: true,
                //         type: `warning`
                //     })
                // }
                that.collectDrugs.datalist = _.filter(templateitems, x => x.dic_drug && x.dic_drug.disabled == false)
                // 可默认全选，但默认全选之后要取消全选，再切换模板才能正常全选新的，不友好，先取消
                // this.$nextTick(() => {
                //     that.$refs.collectDrugslist.selectAll(true)
                // })
            })
        }
    }
}
</script>
<style scoped lang="less">

.inputlocal {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 2px 0px 2px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 175px;
    height: 32px;
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Analgesic/Index.vue